<template>
	<div class="retail-create-container create-container">
		<div class="create-host" v-if="creatVisibile">
			<div class="jc-page-header">
				<div class="jc-container">
					<el-page-header show-back-icon :title="$t('create.text.makeCps')" @back="jump_to_up()" class="relative">
						<template slot="content">
							<div class="jc-list__header--right">
								<a :href="Config.BUY_HELP_URL" target="_blank" class="fr buy-info">
									{{ $t('create.text.buyMustKnow') }}
								</a>
							</div>
						</template>
					</el-page-header>
				</div>
			</div>
			<div class="jc-page-content">
				<div class="jc-container pr">
					<div class="buildTab">
						<ul>
							<li id="tab1" @click="setTab('tab', 1, 2)" class="hover">
								{{ $t('create.text.yearlyOrMonthly') }}

							</li>
							<li id="tab2" @click="setTab('tab', 2, 2)" v-if="isVip">
								{{ $t('create.text.byConfigurations') }}
							</li>
						</ul>
					</div>
					<div class="buildCon" id="con-tab-1">
						<div class="infoBox">
							<!-- 地域与可用区 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.regionAndAz') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<el-form-item :label="$t('create.text.region') | withColon">
										<el-radio-group v-model="selectedRegion" @change="regionChange">
											<el-radio-button v-for="(regionName, region, index) in regions" :key="index"
												:label="region">
												{{ regionName }}
											</el-radio-button>
										</el-radio-group>
										<el-tooltip effect="dark" class="ml10" placement="right">
											<div slot="content" class="my-os-disk-tip">{{ $t('create.tooltip.region') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<el-form-item :label="$t('create.text.az') | withColon">
										<el-radio-group v-model="selectedZone" @change="zonesChange">
											<el-radio-button v-for="(azName, az, index) in zones[selectedRegion]"
												:key="index" :label="az">
												{{ azName }}
											</el-radio-button>
										</el-radio-group>
										<el-tooltip effect="dark" class="ml10" placement="right">
											<div slot="content" class="my-os-disk-tip">{{ $t('create.tooltip.az') }}</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
								</el-form>
							</div>
							<!-- 规格 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.spec') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<el-form-item :label="$t('create.text.series') | withColon">
										<el-radio-group v-model="selectedSeries" @change="changeSeries">
											<el-radio-button class="no-border-left"
												v-for="(series) in Object.keys(deviceTypesTable)" :key="series"
												:label="series">{{ seriesMap[series] }}
											</el-radio-button>
										</el-radio-group>
									</el-form-item>
									<div class="select-type">
										<div class="search-label"><span>{{ $t('detail.text.spec') | withColon }}</span>
										</div>
										<el-input v-model="searchType" :placeholder="$t('retailInstance.text.example')"
											@keyup.enter.native="handleIconClick()" class="search-input"></el-input>
										<el-button type="primary" class="search-icon" @click="handleIconClick()">{{
											$t('retailInstance.text.search') }}</el-button>
									</div>
									<el-form-item>
										<div class="jc-form-box">
											<div style="overflow:hidden;margin-right:-30px;width: 100%">
												<el-table :data="this.deviceTypesTable[this.selectedSeries]"
													:empty-text="$t('retailInstance.text.empty')" class="instance-type"
                                                    style="width: 830px;"
													border>
													<!-- 规格类型 -->
													<el-table-column min-width="330" prop="name"
														:label="$t('create.text.specType')">
														<template slot-scope="scope">
															<el-radio-group
																:disabled="!deviceTypesNum[scope.row.deviceType] || isCalculatIng || isConfigurationsCalculatIng"
																v-model="selectedStandard"
																@click="selectStandard(scope.row.deviceType)">
																<el-radio :label="scope.row.deviceType">
																	<span v-html="isIncludeBra(scope.row.name)"></span>
																</el-radio>
															</el-radio-group>
															<el-tooltip placement="bottom-start"
																v-if="!deviceTypesNum[scope.row.deviceType]">
																<span class="sold-out">{{ $t('create.text.soldOut')
																}}</span>
																<div slot="content" class="my-app-tip"
																	style="max-width:200px;">
																	<span
																		v-if="selectedHostNumber > 1 && !deviceTypesNum[scope.row.deviceType]">{{
																			$t('create.tooltip.notEnough') }}</span>
																	<span v-else>{{ $t('create.tooltip.soldOut') }}</span>{{
																		$t('create.tooltip.cusService') }}<a
																		v-bind:href="Config.WORK_URL" target="_blank"
																		style="color:#2C68FF">{{ $t('create.tooltip.ticket')
																		}}</a>
																</div>
															</el-tooltip>
														</template>
													</el-table-column>
													<!-- 规格 -->
													<el-table-column min-width="200" prop="deviceType"
														:label="$t('create.text.spec')">
														<template slot-scope="scope">
															<span :title="scope.row.deviceType">{{ scope.row.deviceType
															}}</span>
														</template>
													</el-table-column>
													<!-- CPU -->
													<el-table-column prop="cpuDetail" min-width="75"
														:label="$t('create.text.cpu')">
														<template slot-scope="scope">
															<span :title="scope.row.cpuDetail">
																{{ scope.row.cpuDetail }}
															</span>
														</template>
													</el-table-column>
													<!-- 内存 -->
													<el-table-column prop="memConcise" min-width="75"
														:label="$t('create.text.memory')">
														<template slot-scope="scope">
															<span :title="scope.row.memDetail">
																{{ scope.row.memDetail }}
															</span>
														</template>
													</el-table-column>
													<!-- 网卡 -->
													<el-table-column prop="ifConcise" min-width="130"
														:label="$t('create.text.netCard')">
														<template slot-scope="scope">
															<span>{{ scope.row.ifConcise }}</span>
														</template>
													</el-table-column>
													<!-- GPU -->
													<el-table-column prop="gpuConcise" min-width="90"
														:label="$t('create.text.gpu')">
														<template slot-scope="scope">
															<span>{{ scope.row.gpuConcise | maybeEmpty }}</span>
														</template>
													</el-table-column>
												</el-table>
											</div>
										</div>
										<p>{{ $t('create.text.currentDeviceType') }}
											<span class="highlight-font-color">
												{{ currentDeviceType }}
											</span>
											{{ currentDeviceTypeDetail }}
										</p>
										<p class="el-form-item-help custom-margin-top">
											{{ $t('create.help.spec') }}
											<a v-bind:href="Config.TYPE_HELP_URL" target="_blank">
												{{ $t('create.help.detail') }}
											</a>
										</p>
									</el-form-item>
								</el-form>
							</div>
							<!-- 镜像 -->
							<div class="jc-page-card" id="imgType">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.mirror') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px" :model="ruleFormType"
									:rules="rulesType" ref="ruleFormType">
									<el-form-item :label="$t('create.text.mirrorType') | withColon">
                                        <span v-if="!imageTypes.length">--</span>
										<el-radio-group v-model="selectedImageType" v-else>
											<el-radio-button v-for="(item, key, index) in imageTypes" :key="index"
												:label="key">{{ item.sourceName }}
											</el-radio-button>
										</el-radio-group>
									</el-form-item>
									<el-form-item :label="$t('create.text.os') | withColon">
                                        <span v-if="!showOsTypes">--</span>
										<el-radio-group v-model="selectedOS" v-else>
											<el-radio-button v-for="(item, key, index) in osTypes" :key="index"
												:label="key">
											</el-radio-button>
										</el-radio-group>
									</el-form-item>
									<el-form-item :label="$t('create.text.osVersion') | withColon" ref="osVersion" required
										prop="type" :show-message="false">
										<el-select v-model="selectedOSTypeId"
											:placeholder="$t('create.placeholder.version')">
											<el-option v-for="item in osTypes[selectedOS]" :key="item.osTypeId"
												:label="item.osName" :value="item.osTypeId"></el-option>
										</el-select>
									</el-form-item>
								</el-form>
							</div>
							<!-- 存储 -->
							<div class="jc-page-card" id="storage">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.storage') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<el-form-item :label="$t('create.text.sysDisk') | withColon">
										<span>{{ selectedSysRaidName | maybeEmpty }}</span>
										<el-tooltip class="ml10" effect="dark" placement="right" content="Right Top">
											<div slot="content" class="my-os-disk-tip">{{ $t('create.tooltip.sysDisk') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<el-form-item :label="$t('create.text.sysDiskCapacity') | withColon">
										<span>{{ sysDiskCapacity }}</span>
										<span class="el-form-item-help">{{ $t('create.text.sysDiskCapacityUnitTip')
										}}</span>
									</el-form-item>
									<el-form-item :label="$t('retailInstance.text.systemDataPartitions') | withColon">
										<template v-if="systemType === 'windows'">
											<span>{{ $t('retailInstance.text.emptyPartition') }}</span>
										</template>
										<template v-else>
											<el-radio-group v-model="selectedPartitionMode" @change="partitionModeChange">
												<el-radio v-for="(item, index) in systemDiskPartitionModes" :key="index"
													:label="item.value">
													{{ item.label }}
												</el-radio>
											</el-radio-group>
											<el-tooltip class="ml10" effect="dark" placement="right" content="Right Top">
												<div slot="content" class="my-os-disk-tip">
													{{ $t('create.tooltip.systemPartition') }}
												</div>
												<a><i class="jc-icon-question"></i></a>
											</el-tooltip>
											<section class="defaultPartition" v-if="selectedPartitionMode === 'default'"
												v-html="defaultSystemDataPartitions">
											</section>
											<custom-partition ref="systemPartition"
												:visible="selectedPartitionMode === 'custom'" :region="selectedRegion"
												diskType="system" :partitionInfos="systemDataPartitions"
												:otherPartitionInfos="dataDiskPartitions" :isCentOS66="isCentOS66"
												:totalDiskSize="systemDiskSize">
											</custom-partition>
										</template>
									</el-form-item>
									<el-form-item :label="$t('create.text.dataDisk') | withColon">
										<template v-if="raids.length">
											<div v-for="(item, key, index) in raids" :key="index"
												@click="selectDataRaid(item)">
												<el-tooltip class="ml5 mt5" effect="dark" placement="bottom-start"
													content="BOTTOM Center">
													<div slot="content" class="my-os-disk-tip data-disk">
														{{ item.description }}
													</div>
													<el-card :line=true class="deviceType cps-raid-card"
														:class="{ 'selected-box-card': item.raidTypeId == selectedDataRaidId }">
														<div slot="header" class="clear-fix"
															:class="{ 'active-card': item.raidTypeId == selectedDataRaidId }">
															<span class="item text">{{ radisNameMap[item.raidType] }}</span>
														</div>
														<el-form>
															<p class="tc">{{ item.volumeDetail }}</p>
														</el-form>
													</el-card>
												</el-tooltip>
											</div>
										</template>
										<span v-else>--</span>
									</el-form-item>
									<el-form-item v-if="raids.length"
										:label="$t('create.text.dataDiskCapacity') | withColon">
										<span>{{ dataDiskCapacity }}</span>
										<span class="el-form-item-help">{{ $t('create.text.sysDiskCapacityUnitTip')
										}}</span>
									</el-form-item>
									<el-form-item :label="$t('retailInstance.text.dataDiskPartition') | withColon"
										v-if="raids.length">
										<template v-if="systemType === 'windows'">
											<span>{{ $t('retailInstance.text.emptyPartition') }}</span>
										</template>
										<template v-else>
											<el-radio-group v-model="selectedDataDiskPartitionMode"
												@change="partitionModeChange">
												<el-radio v-for="(item, index) in dataDiskPartitionModes" :key="index"
													:label="item.value">
													{{ item.label }}
												</el-radio>
											</el-radio-group>
											<section class="defaultPartition"
												v-if="selectedDataDiskPartitionMode === 'default'"
												v-html="defaultDataDiskPartitions">
											</section>
											<custom-partition ref="dataPartition"
												:visible="selectedDataDiskPartitionMode === 'custom'"
												:region="selectedRegion" diskType="data"
												:partitionInfos="dataDiskPartitions"
												:otherPartitionInfos="systemDataPartitions" :isCentOS66="isCentOS66"
												:totalDiskSize="dataDiskSize">
											</custom-partition>
										</template>
									</el-form-item>
								</el-form>
							</div>
							<!-- 网络数量与名称 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.networkQuantityAndName') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<!--网络接口数量-->
									<el-form-item :label="$t('create.text.networkQuantity') | withColon">
										<el-radio-group v-model="selectedNetworkQuantity">
											<el-radio-button v-for="(item, index) in networkQuantity" :key="index"
												:label="item.value">{{ item.label }}
											</el-radio-button>
										</el-radio-group>
										<el-tooltip class="ml10" effect="dark" placement="right" content="Right Top">
											<div slot="content" class="my-os-disk-tip">
												{{ $t('create.tooltip.networkQuantityTip') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<el-alert v-if="selectedNetworkQuantity === 'dual'" type="info" :closable="false">
											<p slot>{{ $t('retailInstance.tooltip.networkQuantityTip1') }}</p>
											<p slot>{{ $t('retailInstance.tooltip.networkQuantityTip2') }}<copy-value
													:copyVal="dongdongNo" :hasIcon="false"><span slot="content">{{
														dongdongNo }}</span></copy-value></p>
										</el-alert>
									</el-form-item>
									<!--网络接口名称-->
									<el-form-item :label="$t('create.text.networkName') | withColon">
										<span v-if="selectedNetworkQuantity === 'bond'">{{
											$t('create.text.singleInternetAccessChiefName') }}</span>
										<span v-else>
											{{ $t('create.text.chiefAndSubInternetAccessName') }}
										</span>
										<el-tooltip class="ml10" effect="dark" placement="right" content="Right Top">
											<div slot="content" class="my-os-disk-tip">{{ selectedNetworkQuantity ===
												'bond' ? $t('create.tooltip.mainNetwork') : $t('create.tooltip.subNetwork')
											}}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
								</el-form>
							</div>
							<!-- 网口与带宽设置 -->
							<div class="jc-page-card" id="network">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.networkAndBandWidth') }}</h3>
								</div>
								<!-- 主网口 -->
								<div>
									<h3 class="jc-form-content-title">{{ this.selectedNetworkQuantity === 'dual'
										?
										$t('create.text.chiefInternetAccessName') :
										$t('create.text.singleInternetAccessChiefName') }}
									</h3>
									<el-form class="jc-form cps-create-form" label-width="130px" ref="networkInfo"
										:model="netInfo">
										<!-- 内网IP -->
										<el-form-item :label="$t('privateNetInstance.intranetIp') | withColon">
											<div class="ip-input">
												<el-form-item>
													<el-input :disabled="netInfo.isAuto === 1" class="inner-ip"
														:placeholder="$t('privateNetInstance.autoIpTip')">
													</el-input>
												</el-form-item>
											</div>
										</el-form-item>
									</el-form>
								</div>
								<!-- 辅网口 -->
								<div v-if="selectedNetworkQuantity === 'dual'" id="extensionNet" class="extension-net">
									<h3 class="jc-form-content-title-subnet">{{ $t('create.text.subInternetAccessName') }}
									</h3>
									<el-form class="jc-form cps-create-form" label-width="130px" ref="extensionNetInfo"
										:model="extensionNetInfo">
										<!-- 内网IP -->
										<el-form-item :label="$t('privateNetInstance.intranetIp') | withColon">
											<div class="ip-input">
												<el-form-item>
													<el-input :disabled="extensionNetInfo.isAuto === 1" class="inner-ip"
														:placeholder="$t('retailInstance.text.extensionIntraNetIp')">
													</el-input>
													<p class="ml20 el-form-item-help">
														{{ $t('retailInstance.text.contactTip') }}<copy-value
															:copyVal="dongdongNo" :hasIcon="false"><span slot="content">{{
																dongdongNo }}</span></copy-value></p>
												</el-form-item>
											</div>
										</el-form-item>
									</el-form>
								</div>
							</div>
							<!-- 安全设置 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.securityNetwork') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px" onsubmit="return false">
									<!-- 防火墙 -->
									<el-form-item :label="$t('privateNetInstance.firewall') | withColon" class="net-select">
										<el-select v-model="firewall" disabled
											:placeholder="$t('privateNetInstance.notIpTip')">
										</el-select>
										<p slot="hint">
											{{ $t('privateNetInstance.firewallTip') }}
											<a :href="Config.FIRE_HELP_URL" target="_blank">
												{{ $t('privateNetInstance.operateGuid') }}
											</a>
										</p>
									</el-form-item>
								</el-form>
							</div>
							<!-- 基本信息 -->
							<div id="baseInfo" class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.baseInfo') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px" :model="ruleForm"
									ref="ruleForm" :rules="rules">
									<!--实例名称-->
									<el-form-item :label="$t('detail.text.name') | withColon" prop="hostName"
										:show-message="false" required ref="hostName">
										<el-input v-model="ruleForm.hostName" class="w500" @blur="ruleFormTag.hostName = 1"
											@focus="ruleFormTag.hostName = 0"></el-input>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-os-disk-tip">
												{{ $t('create.help.instanceName') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p v-if="ruleFormTag.hostName !== 0 && ruleForm.hostName == ''"
											class="el-form-item-help-error">
											{{ $t('create.placeholder.nameNull') }}</p>
										<p v-else class="el-form-item-help"
											:class="{ 'el-form-item-help-error': this.ruleFormTag.hostName == 'error' }">
											{{ $t('create.help.instanceNameRule1') }}</p>
									</el-form-item>
									<!--描述-->
									<el-form-item :label="$t('create.text.desc') | withColon" prop="hostDesc"
										:show-message="false" ref="hostDesc">
										<el-input type="textarea" :rows="4" class="w500" v-model="ruleForm.hostDesc"
											placeholder=""></el-input>
										<p class="el-form-item-help"
											:class="{ 'el-form-item-help-error': this.ruleFormTag.hostDesc == 'error' }">
											{{ $t('create.help.desc') }}</p>
									</el-form-item>
									<!--主机名-->
									<el-form-item :label="$t('create.text.hostName') | withColon" prop="mainName"
										:show-message="false" ref="mainName">
										<el-input v-model="ruleForm.mainName" class="w500"
											:placeholder="$t('create.placeholder.mainName')"
											@blur="ruleFormTag.mainName = 1" @focus="ruleFormTag.mainName = 0"></el-input>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-os-disk-tip">{{ $t('create.help.hostName') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p class="el-form-item-help"
											:class="{ 'el-form-item-help-error': this.ruleFormTag.mainName == 'error' }">
											{{ $t('create.help.mainServerNameRule') }}</p>
									</el-form-item>
									<el-form-item :label="$t('create.text.username') | withColon">
										<span>{{ hostUserName }}</span>
									</el-form-item>
									<!--登陆方式-->
									<el-form-item :label="$t('create.text.loginMethods') | withColon">
										<input type="radio" v-model="passwordType" value="custom" id="custom"
											class="label-align" />
										<label for="custom">
											{{ $t('create.text.customizedPassword') }}
										</label>
										<input type="radio" v-model="passwordType" value="key" id="key"
											class="auto-password-position label-align" />
										<label for="key">
											{{ $t('create.text.publicKey') }}
										</label>
										<input type="radio" v-model="passwordType" value="auto" id="auto"
											class="auto-password-position label-align" />
										<label for="auto">
											{{ $t('create.text.autoPassword') }}
										</label>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-os-disk-tip">
												{{ $t('create.tooltip.loginTips') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<!--密码-->
									<el-form-item v-if="passwordType === 'custom'"
										:label="$t('create.text.password') | withColon" required prop="hostPwd"
										:show-message="false" ref="hostPwd">
										<el-input class="w500" v-model="ruleForm.hostPwd" type="password"
											auto-complete="off" @blur="ruleFormTag.hostPwd = 1"
											@focus="ruleFormTag.hostPwd = 0"></el-input>
										<p v-if="ruleFormTag.hostPwd !== 0 && ruleForm.hostPwd == ''"
											class="el-form-item-help-error">
											{{ $t('create.placeholder.passNull') }}</p>
										<p v-else class="el-form-item-help"
											:class="{ 'el-form-item-help-error': this.ruleFormTag.hostPwd == 'error' }">
											{{ $t('create.help.password') }}</p>
									</el-form-item>
									<!--确认密码-->
									<el-form-item :label="$t('create.text.passwordConfirm') | withColon" required
										prop="hostConfirmPwd" :show-message="false" ref="hostConfirmPwd"
										v-if="passwordType === 'custom'">
										<el-input class="w500" v-model="ruleForm.hostConfirmPwd" type="password"
											auto-complete="off" @blur="ruleFormTag.hostConfirmPwd = 1"
											@focus="ruleFormTag.hostConfirmPwd = 0"></el-input>
										<p v-if="ruleFormTag.hostConfirmPwd !== 0 && ruleForm.hostConfirmPwd == ''"
											class="el-form-item-help-error">
											{{ $t('create.placeholder.confirmPassNull') }}</p>
										<p v-if="ruleFormTag.hostConfirmPwd !== 0 && ruleForm.hostConfirmPwd !== '' && ruleForm.hostPwd !== ruleForm.hostConfirmPwd"
											class="el-form-item-help-error">{{ $t('create.placeholder.passNotSame') }}</p>
									</el-form-item>
									<!--密钥对多选-->
									<el-form-item :label="$t('create.text.keyPair') | withColon"
										v-if="passwordType === 'key'" prop="selectKey" :show-message="false">
										<secret-key :region="selectedRegion" v-model="ruleForm.selectKey"></secret-key>
									</el-form-item>
								</el-form>
							</div>
							<!-- 高级设置 -->
							<div id="advanced" class="jc-page-card advanced-setting">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.advanced') }}</h3>
								</div>
								<custom-data :setCustomData.sync="advancedSetting" ref="advancedCustomData"
									:region="selectedRegion" :selectedOS="selectedOS" @getCustomData="getCustomData">
								</custom-data>
								<el-form class="jc-form tags-form" :model="tagForm" label-width="130px" :rules="tagRules">
									<el-form-item class="code-value-tip" :label="$t('listPage.text.tags') | withColon">
										<jcb-tag-creationform v-model="tagForm.tags" ref="tagForm"
											:regionId="selectedRegion" @error="errorHandler">
										</jcb-tag-creationform>
									</el-form-item>
								</el-form>
							</div>
							<!-- 购买量 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{ $t('create.text.buyNo') }}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<el-form-item v-if="currentMode === 'tab1'" :label="$t('create.text.buyTimeSpan')">
										<div class="my-time-length">
											<div class="time-slide">
												<ul class="time-choose cl">
													<!--0折用户-->
													<el-tooltip effect="dark" placement="top"
														v-if="allDiscountedInfo[index - 1].message[0] !== ''"
														v-for='index in firstNine'>
														<div slot="content">
															{{ allDiscountedInfo[index - 1].message[0] }} <br />
															{{ allDiscountedInfo[index - 1].message[1] }}
														</div>
														<li @click="selectMonth(index)" :class="getClass(index)">
															<i></i>{{ index }}
														</li>
													</el-tooltip>
													<!--普通用户-->
													<li v-for='index in firstNine' @click="selectMonth(index)"
														:class="getClass(index)"
														v-if="allDiscountedInfo[index - 1].message[0] === ''">
														{{ index }}
													</li>
													<!--0折用户-->
													<el-tooltip effect="dark" placement="top"
														v-if="allDiscountedInfo[index + 8].message[0] !== ''"
														v-for='index in lastThree'>
														<div slot="content">
															{{ allDiscountedInfo[index + 8].message[0] }} <br />
															{{ allDiscountedInfo[index + 8].message[1] }}
														</div>
														<li @click="selectYear(index)" class="time-discount"
															:class="getClass(12 * index)">
															<i></i>{{ index + $tc('create.text.yearUnit', index) }}
														</li>
													</el-tooltip>
													<!--普通用户-->
													<li v-for='index in lastThree' @click="selectYear(index)"
														:class="getClass(12 * index)"
														v-if="allDiscountedInfo[index + 8].message[0] === ''"
														class="time-discount">
														{{ index + $tc('create.text.yearUnit', index) }}
													</li>
												</ul>
											</div>
										</div>
									</el-form-item>
									<!--自动续费-->
									<el-form-item v-if="currentMode === 'tab1'"
										:label="$t('create.text.autoRenew') | withColon">
										<input id="autoRenewCheckbox" type="checkbox" v-model="autoRenew" />
										<span>{{ $t('create.text.autoRenewTip') }}</span>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-app-tip">
												{{ $t('create.tooltip.autoRenew') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<el-form-item :label="$t('create.text.count') | withColon">
										<el-input-number v-model="selectedHostNumber" :min="1"
											:max="netInfo.isAuto ? maxHostNumber : 1" label=""
											@input.native="changeSelectedNumber"></el-input-number>
										<el-tooltip class="ml10" effect="dark" placement="right">
											<div slot="content" class="my-app-tip" v-if="netInfo.isAuto">
												{{ $t('retailInstance.tooltip.maxNum') }}<a :href="Config.WORK_URL"
													target="_blank" style="color:#2C68FF">{{ $t('create.tooltip.ticket')
													}}</a>
											</div>
											<div slot="content" class="my-app-tip" v-else-if="!netInfo.isAuto">
												{{ $t('create.help.onlyOne') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
								</el-form>
							</div>
						</div>
					</div>
					<!-- 已选配置 -->
					<div id="selected" class="jc-form-create-selected">
						<h3 class="selected-title">
							{{ $t('create.text.selectedConfig') }}</h3>
						<el-form label-width="110px" class="jc-datashow-list">
							<section class="selected-configure">
								<!--地域-->
								<el-form-item :label="$t('create.text.region')">
									<p>{{ regions[selectedRegion] | maybeEmpty }}</p>
								</el-form-item>
								<!--可用区-->
								<el-form-item :label="$t('create.text.az')" :title="$t('create.text.az')">
									<p>{{ zones[selectedRegion][selectedZone] | maybeEmpty }}</p>
								</el-form-item>
								<!--规格-->
								<el-form-item :label="$t('create.text.spec')">
									<p class="selected-ellipsis" :title="selectedStandardName">
										{{ selectedStandardName | maybeEmpty }}
									</p>
								</el-form-item>
								<!--镜像-->
								<el-form-item :label="$t('create.text.mirror')">
									<p>
										{{ selectedOSName | maybeEmpty }}
									</p>
								</el-form-item>
								<!--系统盘-->
								<el-form-item :label="$t('create.text.sysDisk')" :title="$t('create.text.sysDisk')">
									<p>
										{{ selectedSysRaidName | maybeEmpty }}
									</p>
								</el-form-item>
								<!--数据盘-->
								<el-form-item :label="$t('create.text.dataDisk')">
									<p class="selected-ellipsis" :title="selectedDataRaidName">
										{{ selectedDataRaidName | maybeEmpty }}
									</p>
								</el-form-item>
								<!--主网口-->
								<div>
									<h3 class="network-title" @click="collapseSelected('netInfo')">
										<span>{{ this.selectedNetworkQuantity === 'dual'
											?
											$t('create.text.chiefInternetAccessName') :
											$t('create.text.singleInternetAccessChiefName') }}</span>
										<i :class="netInfo.collapseSelected ? 'jc-icon-caret-bottom' : 'jc-icon-caret-top'">
										</i>
									</h3>
									<div v-show="!netInfo.collapseSelected">
										<!--内网IP-->
										<el-form-item :label="$t('privateNetInstance.interNetwork')">
											<p>
												{{ $t('privateNetInstance.autoIpTip') }}
											</p>
										</el-form-item>
									</div>
								</div>
								<!--辅网口-->
								<div v-if="selectedNetworkQuantity === 'dual'">
									<h3 class="network-title" @click="collapseSelected('extensionNetInfo')">
										<span>{{ $t('create.text.subInternetAccessName') }}</span>
										<i
											:class="extensionNetInfo.collapseSelected ? 'jc-icon-caret-bottom' : 'jc-icon-caret-top'">
										</i>
									</h3>
									<div v-show="!extensionNetInfo.collapseSelected">
										<!--内网IP-->
										<el-form-item :label="$t('privateNetInstance.interNetwork')">
											<p>
												{{ $t('privateNetInstance.autoIpTip') }}
											</p>
										</el-form-item>
									</div>
								</div>
								<!--购买时长-->
								<el-form-item v-if="currentMode === 'tab1'" :label="$t('create.text.buySpan')"
									:title="$t('create.text.buyTimeSpan')">
									<p v-if="selectedMonth % 12 != 0">
										{{ selectedMonth }} {{ $tc('create.text.month', selectedMonth) }}
									</p>
									<p v-else-if="selectedMonth % 12 == 0">{{ selectedMonth / 12 }}
										{{ $tc('create.text.yearUnit', selectedMonth / 12) }}
									</p>
									<p v-else>--</p>
								</el-form-item>
								<!--购买数量-->
								<el-form-item :label="$t('create.text.buyNum')">
									<p>{{ selectedHostNumber }}</p>
								</el-form-item>
							</section>
							<!--费用-->
							<section class="selected-cost">
								<h3 class="selected-cost-title">
									{{ $t('create.text.cost') }}</h3>
								<!--包年包月计费-->
								<div v-if="currentMode === 'tab1'">
									<!--服务器-->
									<el-form-item :label="$t('create.text.server')">
										<p class="form-item-nopadding"
											:class="[totalDiscount > 0 ? '' : 'form-item-bottom']">
											<span class="price highlight-font-color">￥{{ discountedServerPrice }}</span>
											<span class="none">{{ calTotalPrice.discountedServerPrice }}</span>
										</p>
									</el-form-item>
									<save-price v-if="totalDiscount > 0" :totalDiscount="favorablePricePerHour"
										:originPrice="totalPrice"></save-price>
								</div>
								<!--按配置计费-->
								<div v-else>
									<!--服务器-->
									<el-form-item v-if="currentMode === 'tab2'" :label="$t('create.text.server')">
										<p class="form-item-nopadding"
											:class="[totalDiscount > 0 ? '' : 'form-item-bottom']">
											<span class="price highlight-font-color">
												{{ $t('create.text.feePerHour',
													[discountByConfigurationsServerPriceOneHour]) }}</span>
											<span class="none">{{
												configurationCalTotalPrice.discountByConfigurationsServerPriceOneHour
											}}</span>
										</p>
									</el-form-item>
									<p class="month-total-price">
										<span>{{ $t('create.text.configureMonthPay',
											[discountByConfigurationsOneMonthPrice]) }}</span>
										<span class="none">{{
											configurationCalTotalPrice.discountByConfigurationsOneMonthPrice }}</span>
										<span class="none">{{ calTotalPrice.discountedServerPrice }}</span>
									</p>
									<save-price v-if="configurationTotalDiscount > 0"
										:totalDiscount="configurationTotalDiscount"
										:originPrice="configurationTotalPrice"></save-price>
								</div>
								<el-button type="primary" size="large" :disabled="!isStockEnough
									|| moreThanAvailableQuota
									|| !selectedStandard
									|| !isCertification" class="my-buy-btn" @click="buy">{{ isBuyTag }}
								</el-button>
								<p v-if="currentMode === 'tab2'" class="like-form-help-item">
									{{ $t('create.text.yearPackage', [discountedTotalPrice]) }}
								</p>
								<p v-if="!isCertification" class="red mt10">
									{{ $t('create.help.noCertification') }}
									<a :href="Config.REALNAME_URL">
										{{ $t('create.help.goCertificate') }}</a>
								</p>
								<p v-else-if="!isStockEnough" class="red mt10">
									<span v-if="cacheDeviceTypesNum[selectedStandard]">{{ $t('create.help.restock')
									}}</span>
									<span v-else>{{ $t('create.help.soldOut') }}</span>{{ $t('create.help.contact') }}
									<a v-bind:href="Config.WORK_URL" target="_blank">{{ $t('create.tooltip.ticket') }}</a>
								</p>
								<p v-else-if="isStockEnough && moreThanAvailableQuota" class="red">
									{{ $t('create.help.CPSOverStock') }}{{ $t('create.help.contact') }}
									<a v-bind:href="Config.WORK_URL" target="_blank">{{ $t('create.tooltip.ticket') }}</a>
								</p>
								<p v-else-if="isStockEnough && selectedStandard == ''" class="red mt10">
									<span v-if="cacheDeviceTypesNum[selectedStandard]">{{ $t('create.help.restock')
									}}</span>
									<span v-else>{{ $t('create.help.soldOut') }}</span>{{ $t('create.help.contact') }}
									<a v-bind:href="Config.WORK_URL" target="_blank">{{ $t('create.tooltip.ticket') }}</a>
								</p>
							</section>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import VueCookie from 'vue-cookie';
import { CreateTypeConstant, I18nConstant, ServiceCodeConstant, PasswordRuleConstant, BillingTypesConstant, CustomPartitionSupportConstant } from '@/common/Constants';
import CustomPartition from '@/components/common/customPartition/customPartition';
import CustomData from '@/components/common/customData/CustomData';
import SavePrice from '@/components/common/SavePrice';
import SecretKey from '@/components/common/secretKey/SecretKey';
import { changeTwoDecimal, mulDecimals, subDecimals } from '@/common/tool';
import copyValue from '@/components/privateNetwork/CopyValue';
import { deepCopy } from '@/common/tool';
import initSelectedPotision from '@/mixins/initSelectedPotision';
import buyTime from '@/mixins/buyTime';
import ifCertification from '@/mixins/ifCertification';
export default {
	components: {
		CustomPartition,
		CustomData,
		copyValue,
		SavePrice,
		SecretKey
	},
	mixins: [initSelectedPotision, buyTime, ifCertification],
	data() {
		const validatePassword = (rule, value, callback) => {
			var rule = PasswordRuleConstant
			const result = rule.test(value);
			if (!result) {
				callback(new Error(this.$t('create.placeholder.passNotMeetRequire')));
				return;
			}
			callback();
		};

		const validateConfirmPassword = (rule, value, callback) => {
			if (value == '') {
				callback(new Error(this.$t('create.placeholder.passNotMeetRequire')));
			} else if (value != this.ruleForm.hostPwd) {
				callback(new Error(this.$t('create.placeholder.passwordNotSame')));
			} else {
				callback();
			}
		};

		const validateHostName = (rule, value, callback) => {
			const reg = /(^((?!(^-)|(-$)|(--+)|(^\\.)|(\\.$)|(\\.\\.+))[0-9A-Za-z-.{}]){2,64}$)|(^\s*$)/;
			if (value != '') {
				const result = reg.test(value);
				if (!result) {
					callback(new Error(this.$t('create.placeholder.hostNameNotRequire')));
					return;
				}
			}
			callback();
		};
		const standardImage = this.$t('create.text.standardImage');
		const standardAppImage = this.$t('create.text.standardAppImage');

		return {
			currentMode: 'tab1',
			isVip: false, // 是否为大客户(true: 是)
			// 高级设置内容，已base64过
			userData: '',
			dongdongNo: '1020848836',
			// 高级设置是否选中
			advancedSetting: false,
			tagForm: {
				tags: []
			},
			tagRules: {

			},
			// 设置密码选中的类型
			passwordType: 'custom',
			netInfo: {
				isAuto: 1,
				collapseSelected: true,
			},
			extensionNetInfo: {
				isAuto: 1,
				collapseSelected: true
			},
			firewall: '',
			quotaState: -100,
			quotaNumber: 0,
			creatVisibile: false,
			ruleFormType: {
				type: this.selectedOSTypeId,
				application: this.selectedApplication
			},
			// 区域
			selectedRegion: '',
			selectedZone: '',
			// 规格
			selectedStandard: '',
			selectedStandardName: '',
			deviceCustomPartitionSupport: true,
			//查询规格
			searchType: '',
			// 镜像
			selectedImageType: 0,
			selectedOS: '',
			selectedOSTypeId: '',
			isCentOS66: false,
			selectedApplication: [],
			// 存储
			sysDiskCapacity: '',
			dataDiskCapacity: '',
			systemDiskPartitionModes: [
				{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' },
				{ id: 2, label: this.$t('create.text.customPartitionModes'), value: 'custom' },
			],
			selectedPartitionMode: 'default',
			defaultSystemDataPartitions: '',
			systemDataCustomPartitionVisible: false,
			systemDataPartitions: [],
			systemDiskSize: 0,
			dataDiskPartitionModes: [
				{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' },
				{ id: 2, label: this.$t('create.text.customPartitionModes'), value: 'custom' },
			],
			selectedDataDiskPartitionMode: 'default',
			defaultDataDiskPartitions: '',
			dataDiskPartitions: [],
			dataDiskSize: 0,
			selectedSysRaidName: '',
			selectedSysRaidTip: '',
			selectedDataRaidName: '',
			selectedOSRaidId: '',
			selectedDataRaid: {},
			selectedDataRaidId: '',
			stockEnough: false,
			// 网络数量与名称
			selectedNetworkQuantity: 'bond',
			networkQuantity: [
				{ id: 1, label: this.$t('create.text.singleInternetAccess'), value: 'bond' },
				{ id: 2, label: this.$t('create.text.doubleInternetAccess'), value: 'dual' },
			],
			// 基本信息
			hostName: '',
			hostDesc: '',
			hostUserName: 'root',
			hostPwd: '',
			hostConfirmPwd: '',
			// 购买数量
			selectedMonth: 1,
			cutMonth: 0,
			selectedHostNumber: 1,
			maxHostNumber: 100,
			// 实名认证
			isCertification: true,
			isBuyTag: this.$t('create.text.buyNow'),
			// 库存
			isStockEnough: true,
			// 包年包月价格
			isCalculatIng: false, // 包年包月计费中
			discountedTotalPrice: '--',
			discountedServerPrice: '--',
			totalPrice: 0,
			totalDiscount: 0,
      favorablePricePerHour: '', // // 省 = 原价 - 应付
			// 按配置价格
			isConfigurationsCalculatIng: false, // 按配置计费中
			discountByConfigurationsOneMonthPrice: '--',
			discountByConfigurationsServerPriceOneHour: '--',
			configurationTotalPrice: '--', // 按配置计价总费用
			configurationTotalDiscount: '--', // 按配置计价折扣额
			// 页面参数选择
			regions: {},
			zones: { '': {} },
			deviceTypes: {},
			// 不同规格类型的库存数量
			deviceTypesNum: {},
			cacheDeviceTypesNum: {},
			// 用于页面倒叙展示规格
			deviceTypesArr: [],
			imageTypes: [],
			osTypes: {},
			standardOsTypes: {},
			customOsTypes: {},
			applications: [],
			otherMonth: 0,
			raids: [],
			// 数据盘提示列表
			radisNameMap: {
				NORAID: 'NO RAID',
				RAID0: 'RAID0',
				RAID1: 'RAID1',
				RAID10: 'RAID10',
				RAID5: 'RAID5',
				RAID51H: 'RAID 5+1 hotspare+NO RAID'
			},
			customRaidsNameMap: {
				RAID51H: 'RAID 5+1 hotspare',
				NORAID: 'NO RAID'
			},
			// 表单验证
			ruleForm: {
				hostName: '',
				hostDesc: '',
				hostPwd: '',
				hostConfirmPwd: '',
				mainName: '',
				publicKey: [], // 密钥对
				selectKey: '' // 选中的密钥对
			},
			ruleFormTag: {
				hostName: 0,
				hostDesc: 0,
				hostPwd: 0,
				hostConfirmPwd: 0,
				application: 0,
			},
			rulesType: {
				type: [
					{
						required: true,
						message: this.$t('privateNetInstance.empty'),
						trigger: 'change'
					}
				]
			},
			rules: {
				hostName: [
					{
						type: 'string',
						pattern: new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:{}]{1,127})$'),
						trigger: 'blur'
					}
				],
				hostDesc: [
					{ type: 'string', pattern: new RegExp('^.{0,256}$'), trigger: 'blur' }
				],
				hostPwd: [
					{ validator: validatePassword, trigger: 'blur' }
				],
				hostConfirmPwd: [
					{ validator: validateConfirmPassword, trigger: 'blur' }
				],
				mainName: [
					{ validator: validateHostName, trigger: 'blur' }
				],
				selectKey: [
					{ required: true, trigger: 'change' }
				]
			},
			regionChanged: false,
			timeUnit: 3,
			chargeUnit: 3, // 月 计费时长单位 1:小时 2:天 3:月 4:年,
			selectedYear: 1, // 选择年份,
			autoRenew: false,//自动续费
			allSold: true,
			deviceTypesTable: [], // 系列对应的机型列表数据
			deviceTypesTableData: [],
			deviceTypesTableData1: [],
			deviceTypesTableData2: [],
			selectedSeries: 'compute', // 所选系列，默认选择计算型,
			seriesMap: {
				// 系列对应的中文名称
				compute: this.$t('create.text.computeType'),
				storage: this.$t('create.text.storageType'),
				gpu: this.$t('create.text.gpuType')
			},
			// 折扣信息
			discountedInfo: [
				{ message: '' },
				{ message: '' },
				{ message: '' }
			],
			// 0折用户折扣信息
			allDiscountedInfo: [
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
				{ message: [] },
			],
			// 前9个月
			firstNine: [1, 2, 3, 4, 5, 6, 7, 8, 9],
			// 后三年
			lastThree: [1, 2, 3],
            showOsTypes: false,
		};
	},
	computed: {
		selectedOSName() {
			if (this.selectedOS && this.selectedOSTypeId) {
				for (const i in this.osTypes[this.selectedOS]) {
					if (this.osTypes[this.selectedOS][i].osTypeId == this.selectedOSTypeId) {
						return this.osTypes[this.selectedOS][i].osName;
					}
				}
			}
			return '';
		},
		systemType() {
			return this.selectedOS === 'Windows' ? 'windows' : 'linux';
		},
		/**
		  * 包年包月计算
		  */
		calTotalPrice() {
			return this.calculateTotalPrice();
		},
		/**
		* 按配置计算
		*/
		configurationCalTotalPrice() {
			return this.configurationsCalculateTotalPrice();
		},
		ServiceCodeConstant: () => ServiceCodeConstant,

		moreThanAvailableQuota() {
			return this.quotaNumber < this.selectedHostNumber;
		},
		currentDeviceType() {
			return this.selectedStandard;
		},
		currentDeviceTypeDetail() {
			if (this.deviceTypes[this.selectedStandard]) {
				return `(${this.deviceTypes[this.selectedStandard].name} ,${this.deviceTypes[this.selectedStandard].cpuConcise} ${this.deviceTypes[this.selectedStandard].memConcise})`;
			}
		},
		/**
		 * 密钥对下拉列表
		 * @return array
		 */
		keyShowList() {
			if (this.ruleForm.publicKey.length) {
				return this.ruleForm.publicKey.map(key => ({
					keypairId: key.keypairId,
					name: key.name,
					publicKey: key.publicKey
				}));
			}
		},

	},
	watch: {
		/**
		 * 设置密码类型改变时，初始化密码和确认密码内容及校验
		 * 暂定为watch，找不到@change可用
		 * @param newVal
		 */
		passwordType(newVal) {
			this.$refs.ruleForm.clearValidate(['hostPwd', 'hostConfirmPwd', 'selectKey']);
			this.ruleForm.hostPwd = '';
			this.ruleForm.hostConfirmPwd = '';
			this.ruleForm.selectKey = '';
			this.ruleFormTag.hostPwd = 0;
			this.ruleFormTag.hostConfirmPwd = 0;
			if (newVal === 'key') {
				this.getPublicKey();
			}
		},
		quotaState(newValue, oldValue) {
			if (newValue === 1) {
				this.creatVisibile = true;
			} else {
				this.creatVisibile = false;
			}
		},
		selectedRegion(newValue, oldVlue) {
			if (newValue) {
				if (this.zones[this.selectedRegion]) {
					for (const az in this.zones[this.selectedRegion]) {
						this.selectedZone = az;
						break;
					}
				} else {
					this.selectedZone = '';
				}
				this.getDeviceType();
				this.getQuota();
				this.regionChanged = true;
				this.selectedStandard = '';
			}
		},
		deviceTypesNum(newValue, oldVlue) {
			const flag = false;
			if (newValue === 1) {
				for (const key in newValue) {
					if (newValue[key]) {
						this.flag = true;
					}
				}
				this.stockEnough = flag;
			}
		},
		selectedZone(newValue, oldVlue) {
			if (newValue) {
				this.getQuota();
				this.getDeviceType();
				this.selectedStandard = '';
			}
		},
		selectedSeries(val) {
			if (val) {
                // 历史逻辑：先清空selectedStandard再回填，会重复触发selectedStandard赋值
                // this.selectedStandard = '';
                this.osTypes[this.selectedOS] = [];
				this.searchType = '';
				this.handleIconClick();
			}
            this.initSelectedStandardBySeries(this.selectedSeries);
		},
		selectedStandard(newValue, oldVlue) {
			if (newValue == '') {
				this.selectedStandardName = '';
			} else if (this.deviceTypes[newValue] != undefined) {
				this.selectedStandardName = `${this.selectedStandard
					}(${this.deviceTypes[newValue].cpuDetail} ${this.deviceTypes[newValue].memDetail},${this.deviceTypes[newValue].name})`;
				this.getAvailableOS(this.selectedImageType);
				this.getAvailableRaids(newValue);
				this.checkStockEnough(this.selectedRegion, this.selectedZone, newValue, this.selectedHostNumber);
				let customPartitionSupport = this.deviceTypes[newValue].customPartitionSupport
				this.deviceCustomPartitionSupport = CustomPartitionSupportConstant[customPartitionSupport];
				this.resetPartitionModes(this.deviceCustomPartitionSupport);
                this.showOsTypes = true;
			}
			this.selectedOSTypeId = '';
		},
		selectedOS(newValue, oldValue) {
			this.$refs.osVersion.resetField();
			this.selectedOSTypeId = '';
            // 重置为默认分区后，清空自定义分区数据
            this.systemDataPartitions = []; // 系统盘
            this.dataDiskPartitions = []; // 数据盘
            this.selectedPartitionMode = 'default';
			this.selectedDataDiskPartitionMode = 'default';
		},
		selectedOSTypeId(newValue, oldVlue) {
			this.ruleFormType.type = newValue;
			this.selectedApplication = [];
			if (!newValue) {
				return
			}
			let customPartitionSupport = this.deviceCustomPartitionSupport;
			let isQcow2 = this.osTypes[this.selectedOS].filter(item => item.osTypeId === newValue).every(item => item.osFormat === 'qcow2');
			this.resetPartitionModes(customPartitionSupport && !isQcow2);
			this.resetDataPartitionModes(this.selectedDataRaid);
			this.getOSPartitions();
		},
		selectedOSName(newValue, oldValue) {
			let spaceReg = /\s+/g;
			let osName = newValue.split(spaceReg).splice(0, 2).join(' ');
			// CentOS 6.6自定义分区文件系统特殊处理标识
			if (osName === 'CentOS 6.6') {
				this.isCentOS66 = true;
			} else {
				this.isCentOS66 = false;
			}

		},
		selectedImageType(newValue, oldVlue) {
			if (newValue !== 'standard_app') {
				this.osTypes = $.extend(true, {}, this.standardOsTypes);
			} else {
				this.selectedOS = 'CentOS';
				this.osTypes = $.extend(true, {}, this.customOsTypes);
			}
			this.getAvailableOS(this.selectedImageType);
			this.$refs.osVersion.resetField();
			this.selectedOSTypeId = '';
			this.selectedApplication = [];
		},
		selectedApplication(newValue, oldVlue) {
			this.ruleFormType.application = newValue;
			if (newValue.length) {
				this.ruleFormTag.application = 0;
			}
		},
		selectedPartitionMode(newValue, oldVlue) {
			if (newValue === 'default') {
                // 重置为默认分区后，清空 系统盘 自定义分区数据
                this.systemDataPartitions = [];
				this.resetDiskCapacity('system');
			}
		},
		selectedDataDiskPartitionMode(newValue, oldVlue) {
			if (newValue === 'default') {
                // 重置为默认分区后，清空 数据盘 自定义分区数据
                this.dataDiskPartitions = []; // 数据盘
				this.resetDiskCapacity('data');
			}
		},
		// 切换后面数量的时候，要查一下库存，是否满足当前数量
		selectedHostNumber(newValue, oldVlue) {
			for (let i = 0; i < this.deviceTypesArr.length; i++) {
				this.checkStockEnough(this.selectedRegion, this.selectedZone, this.deviceTypesArr[i].deviceType, newValue);
			}
		},
		'netInfo.isAuto': function (newVal) {
			if (newVal === 0) {
				this.selectedHostNumber = 1;
			}
		},
	},
	created() {
		this.getQuota();
		this.getRegion();
	},
	methods: {
		/**
		* 获得用户类型
		*/
		getUserType() {
			const params = {
				region: this.selectedRegion
			};
			Ajax.get('/api/usercenter/describeBaseInfo', params)
				.then((res) => {
					res.data = JSON.parse(res.data.meta);
					if (typeof res.data.edcps_vip !== 'undefined') {
						this.isVip = res.data.edcps_vip.toString() === '1';
						this.setTab('tab', 1, 1)
					}
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		// 只能输入整数
		changeSelectedNumber(val) {
			clearTimeout(this.inputNumberTimeout);
			this.inputNumberTimeout = setTimeout(() => {
				let v = val.target.value;
				v = v.replace(/[^0-9]/ig, '');
				this.selectedHostNumber = v
			}, 200)
		},
		/**
		 * 跳转密钥列表
		 */
		jumpToKeys() {
			this.$router.push({
				path: '/ssh/list',
				query: {
					region: this.selectedRegion
				}
			});
		},
		/**
		 * 密钥对select为下拉状态时调用
		 * 获得最新密钥对信息
		 * @param tag
		 */
		getRealTimePublicKey(visible) {
			if (visible) {
				this.getPublicKey();
			}
		},
		/**
		 * 获得密钥对
		 * 当登陆方式为'密钥登陆'时调用
		 * 没有分页，所以pageSize为200
		 */
		getPublicKey() {
			const params = {
				region: this.selectedRegion,
				pageSize: 200
			};
			Ajax.get('/api/cps/listKeypairs', params)
				.then((res) => {
					this.ruleForm.publicKey = res.data.keypairs;
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		/**
		 * 获得通过校验的输入内容
		 * 且内容已经base64过了
		*/
		getCustomData(value) {
			this.userData = value;
		},
		/**
		 * 区域切换时更新数据
		 * 切换时带宽值，购买数量初始化为1
		 * @param region
		 * */
		regionChange(region) {
			this.selectedHostNumber = 1;
			this.ruleForm.selectKey = '';
			this.clearPrice();
			setTimeout(() => {
				this.$refs.ruleForm.clearValidate(['selectKey']);
			}, 2000);
			this.selectedRegion = region;
		},
		zonesChange() {
			this.selectedStandard = '';
			this.clearPrice();
		},
		changeSeries() {
			this.clearPrice();
		},
		clearPrice() {
			this.discountedTotalPrice = '--';
			this.discountedServerPrice = '--';
			this.discountByConfigurationsOneMonthPrice = '--';
			this.discountByConfigurationsServerPriceOneHour = '--';
			this.favorablePricePerHour = '--';
			this.totalPrice = '--';
			this.configurationTotalDiscount = '--';
			this.configurationTotalPrice = '--';
			this.totalDiscount = '--';
		},

		handleIconClick() {
			var keyWord = this.searchType.replace(/\s+|\t+/g, '');
			let target = [];
			if (this.selectedSeries === 'compute') {
				var typeInfo = this.deviceTypesTableData
			} else if (this.selectedSeries === 'storage') {
				var typeInfo = this.deviceTypesTableData1
			} else if (this.selectedSeries === 'gpu') {
				var typeInfo = this.deviceTypesTableData2
			};

			for (let i in typeInfo) {
				let allDeviceType = typeInfo[i].deviceType;
				if (allDeviceType.match(keyWord)) {
					target.splice(target.length, 0, typeInfo[i]);
				}
			}
			if (keyWord != '') {
				this.deviceTypesTable[this.selectedSeries] = target;
			} else if (this.selectedSeries === 'compute' && keyWord === '') {
				this.deviceTypesTable[this.selectedSeries] = this.deviceTypesTableData;
			} else if (this.selectedSeries === 'storage' && keyWord === '') {
				this.deviceTypesTable[this.selectedSeries] = this.deviceTypesTableData1;
			} else if (this.selectedSeries === 'gpu' && keyWord === '') {
				this.deviceTypesTable[this.selectedSeries] = this.deviceTypesTableData2;
			}
		},

		getClass(num) {
			if (VueCookie.get(this.GLOBALCOOKIE) == I18nConstant.CN || VueCookie.get(this.GLOBALCOOKIE) == null) {
				if (num === this.selectedMonth) {
					return 'cur';
				}
				if (this.selectedMonth > num) {
					return 'sel';
				}
				return '';
			}
			if (VueCookie.get(this.GLOBALCOOKIE) == I18nConstant.EN) {
				if (num === this.selectedMonth) {
					if (this.selectedMonth == 1) {
						return 'curSingleEn curEn';
					}
					return 'curEn';
				}
				if (this.selectedMonth > num) {
					return 'sel';
				}
				return '';
			}
		},

		getQuota() {
			const param = {
				serviceCode: ServiceCodeConstant.CPS
			};
			Ajax.get('/api/bm/getUserQuotas', param)
				.then((res) => {
					this.quotaState = 1;
					this.quotaNumber = res.data.userQuotas[this.selectedRegion];
				}).catch(async (err) => {
					this.quotaState = -99;
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});

		},
		getRegion() {
			const param = {
				networkType: 'retail'
			};
			Ajax.get('/api/cps/getRegions', param)
				.then((res) => {
					for (const i in res.data.regions) {
						const region = res.data.regions[i].region;
						const regionName = res.data.regions[i].regionName;
						const zones = res.data.regions[i].azs;
						this.regions[region] = regionName;
						for (const j in zones) {
							const az = zones[j].az;
							const azName = zones[j].azName;
							if (typeof this.zones[region] === 'undefined') {
								this.zones[region] = {};
							}
							this.zones[region][az] = azName;
						}
					}
					const passedRegion = this.$route.query.region;
					if (passedRegion != undefined) {
						this.selectedRegion = passedRegion;
						this.selectedZone = this.regions[passedRegion];
					} else {
						this.selectedRegion = res.data.regions[0].region;
						this.selectedZone = res.data.regions[0].azs[0].az;
					}
					this.getDiscountInfo();
					this.getUserType();
				}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		isSkuSoldOut(isSoldOut) {
			return isSoldOut === true || isSoldOut === 'true' || isSoldOut === 1 || isSoldOut === '1';
		},
		initSelectedStandardBySeries(series) {
			const deviceTypesTableList = (this.deviceTypesTable && this.deviceTypesTable[series]) || [];
			// 历史逻辑：仅当列表首项未售罄时默认选中首项
			// if (deviceTypesTableList && !deviceTypesTableList[0]?.isSoldOut) {
			// 	this.selectedStandard = deviceTypesTableList[0]?.deviceType;
			// }
			// 新逻辑：默认选中当前系列第一个未售罄sku
			const availableSku = deviceTypesTableList.find(item => item && !this.isSkuSoldOut(item.isSoldOut));
			if (availableSku) {
				this.selectedStandard = availableSku.deviceType;
			} else {
				this.selectedStandard = '';
			}
			this.showOsTypes = !!this.selectedStandard;
		},
		getDeviceType() {
			this.deviceTypesArr = [];
			this.deviceTypesNum = [];
			Ajax.get({
				action: '/getAvailableDeviceTypes',
				param: { region: this.selectedRegion, az: this.selectedZone },
				success: (data) => {
					const deviceTypes = {};
					const deviceTypesNum = {};
					this.deviceTypesTable = data.deviceTypes;
					const seriesKeys = Object.keys(this.deviceTypesTable);
					let defaultSeries = seriesKeys[0] || '';
					this.deviceTypesTableData = deepCopy(this.deviceTypesTable[seriesKeys[0]]);
					this.deviceTypesTableData1 = deepCopy(this.deviceTypesTable[seriesKeys[1]]);
					this.deviceTypesTableData2 = deepCopy(this.deviceTypesTable[seriesKeys[2]]);
					// 历史逻辑：按 gpu -> storage -> compute 多次覆盖 selectedSeries
					// if (this.deviceTypesTableData2) {
					// 	this.deviceTypesTableData2.map((item) => {
					// 		if (!item.isSoldOut) {
					// 			this.selectedSeries = 'gpu'
					// 		}
					// 	})
					// }
					// if (this.deviceTypesTableData1) {
					// 	this.deviceTypesTableData1.map((item) => {
					// 		if (!item.isSoldOut) {
					// 			this.selectedSeries = 'storage'
					// 		}
					// 	})
					// }
					// if (this.deviceTypesTableData) {
					// 	this.deviceTypesTableData.map((item) => {
					// 		if (!item.isSoldOut) {
					// 			this.selectedSeries = 'compute'
					// 		}
					// 	})
					// }
					// 新逻辑：仅计算一次默认系列（优先 compute -> storage -> gpu 的未售罄系列）
					const seriesPriority = ['compute', 'storage', 'gpu'];
					for (let i = 0; i < seriesPriority.length; i++) {
						const series = seriesPriority[i];
						const seriesList = this.deviceTypesTable[series] || [];
						if (seriesList.some(item => item && !this.isSkuSoldOut(item.isSoldOut))) {
							defaultSeries = series;
							break;
						}
					}
					for (var i in data.deviceTypes) {
						for (const item in data.deviceTypes[i]) {
							const nameEN = data.deviceTypes[i][item].deviceType;
							deviceTypes[nameEN] = data.deviceTypes[i][item];
							this.deviceTypesArr.push(data.deviceTypes[i][item]);
							this.deviceTypesNum[nameEN] = 1;
						}
					}
					for (let z = 0; z < this.deviceTypesArr.length; z++) {
						this.checkStockEnough(this.selectedRegion, this.selectedZone,
							this.deviceTypesArr[z].deviceType, this.selectedHostNumber, true);
					}
					this.deviceTypes = deviceTypes;
					this.deviceTypesNum = deviceTypesNum;
					// 历史逻辑（初始化阶段在getDeviceType中多分支赋值selectedStandard）已注释
					// selectedStandard 初始化统一由 selectedSeries 监听处理：
					// 默认选择“当前系列第一个未售罄sku”，避免重复赋值覆盖
					// if (this.allSold) {
					// 	// this.selectedStandard = this.deviceTypesArr[0].deviceType
					//     this.selectedStandard = '';
					// } else if (this.deviceTypesArr.length > 1) {
					// 	for (var i = 0; i < this.deviceTypesArr.length; i++) {
					// 		if (this.deviceTypesNum[this.deviceTypesArr[i].deviceType]) {
					// 			this.selectedStandard = this.deviceTypesArr[i].deviceType;
					// 			break;
					// 		}
					// 	}
					// } else if (this.deviceTypesArr.length = 1) {
					// 	this.selectedStandard = this.deviceTypesArr[0].deviceType;
					// }
					const oldSelectedSeries = this.selectedSeries;
					this.selectedSeries = defaultSeries;
					// 当系列值未变化时，watch(selectedSeries)不会触发，需在初始化链路兜底赋值
					if (oldSelectedSeries === defaultSeries) {
						this.initSelectedStandardBySeries(defaultSeries);
					}
				}

			});
		},
		getAvailableOS(selectedImage) {
			const param = { region: this.selectedRegion, deviceType: this.selectedStandard };

			Ajax.get({
				action: '/getAvailableOS',
				param,
				success: (data) => {
					const osTypes = {};
					const imageTypes = [];
					this.customOsTypes = {};
					// 用来验证版本是不是最新的版本，将最新的版本放在最上面
					let osVersionOne = 10000;
					let osVersionTwo = 10000;
					let dataList = [];
					for (const i in data.oss) {
						const image = {};
						image.source = data.oss[i].source;
						image.sourceName = data.oss[i].sourceName;
						imageTypes.push(image)
					}
					var obj = {};
					this.imageTypes = imageTypes.reduce(function (item, next) {
						obj[next.source] ? '' : obj[next.source] = true && item.push(next);
						return item;
					}, []);
					dataList = data.oss.filter(item => item.source === this.imageTypes[selectedImage].source);
					for (const i in dataList) {
						const osTypeId = dataList[i].osTypeId;
						const osType = dataList[i].osType;
						const osName = dataList[i].osName;
						const osFormat = dataList[i].format;
						if (!osTypes[osType]) {
							osTypes[osType] = [];
						}

						if (dataList[i].osVersion < osVersionOne) {
							osTypes[osType].push({ osTypeId, osName, osFormat });
						} else {
							osTypes[osType].splice(0, 0, { osTypeId, osName, osFormat });
							osVersionOne = dataList[i].osVersion;
						}

						if (osType !== 'Ubuntu') {
							if (this.customOsTypes[osType] === undefined) {
								this.customOsTypes[osType] = [];
							}
							if (dataList[i].osVersion < osVersionTwo) {
								this.customOsTypes[osType].push({ osTypeId, osName, osFormat });
							} else {
								this.customOsTypes[osType].splice(0, 0, { osTypeId, osName, osFormat });
								osVersionTwo = dataList[i].osVersion;
							}
						}
					}
					this.osTypes = osTypes;
					this.standardOsTypes = $.extend(true, {}, this.osTypes);
					if (osTypes.CentOS) {
						this.selectedOS = 'CentOS';
					} else {
						// this.selectedOS = dataList[0].osType;
                        // 切换radio 筛选当前选中的镜像类型，用于默认选中第一个的操作系统 selectedImageType: 0-公共镜像，1-定制镜像，默认0
                        const selectedImageTypeData = this.imageTypes[this.selectedImageType];
                        const selectedOSData = data?.oss?.length && data.oss.find(item => {
                            return selectedImageTypeData.source === item.source;
                        });
                        // 增加容错
                        this.selectedOS = selectedOSData ? selectedOSData?.osType : dataList[0]['osType'];
					}
					if (this.imageTypes[this.selectedImageType].source !== 'standard_app') {
						this.osTypes = $.extend(true, {}, this.standardOsTypes);
					} else {
						this.selectedOS = 'CentOS';
						this.osTypes = $.extend(true, {}, this.customOsTypes);
					}

                    // 轮询 this.osTypes ，用于判断操作系统是否选择 --
                    // this.showOsTypes = false;
                    // for (const key in this.osTypes) {
                    //     if (this.osTypes[key] && this.osTypes[key]?.length) {
                    //         this.showOsTypes = true;
                    //     }
                    // }
				}
			});
		},
		getAvailableRaids(selectedStandard) {
			if (!selectedStandard) return;
			Ajax.get({
				action: '/getAvailableRaids',
				param: {
					deviceType: selectedStandard,
					region: this.selectedRegion
				},
				success: (data) => {
					const raids = [];
					for (const i in data.raids) {
						// 系统盘raids
						if (data.raids[i].volumeType == 'system') {
							const volume1 = data.raids[i].volumeDetail.split('(').join(' (');
							const volume = volume1.split(')');
							const raidType = ` ${this.radisNameMap[data.raids[i].raidType]})`;
							const newRaidName = volume + raidType;
							let sysDiskCapacity = data.raids[i].availableValue;
							let systemPartitionCount = data.raids[i].systemPartitionCount;
							sysDiskCapacity = sysDiskCapacity / systemPartitionCount;
							this.calculateDiskCapacity('system', sysDiskCapacity);
							this.selectedSysRaidName = newRaidName;
							this.selectedSysRaidTip = data.raids[i].description;
							this.selectedOSRaidId = data.raids[i].raidTypeId;
						} else { // 数据盘raids
							if (data.raids[i].raidType === 'NO RAID') {
								raids.splice(0, 0, data.raids[i]);
							} else {
								raids.push(data.raids[i]);
							}
						}
					}
					this.raids = raids;
					//优化根据不同的机型设置默认选中的不同raid卡逻辑
					if (raids.length > 0) {
						this.selectedDataRaid = raids[raids.length - 1];
						this.resetDataPartitionModes(this.selectedDataRaid);
						this.selectedDataRaidId = this.selectedDataRaid['raidTypeId']
						let dataVolume1 = this.selectedDataRaid['volumeDetail']
						let dataVolume2 = dataVolume1.split('TB').join('TB ')
						let dataVolume = dataVolume2.split('GB').join('GB ')
						var dataRaidType = ', ' + this.radisNameMap[this.selectedDataRaid['raidType']] + ')';
						let dataDiskCapacity = this.selectedDataRaid.availableValue;
						this.calculateDiskCapacity('data', dataDiskCapacity);
						var dataRaidName = dataVolume.replace(')', dataRaidType);
						this.selectedDataRaidName = dataRaidName;
					} else {
						this.selectedDataRaidName = '';
						this.selectedDataRaidId = '';
					}
				}
			});
		},

		// noraid数据盘分区模式特殊处理
		resetDataPartitionModes(item) {
			// 机型不支持自定义分区就不需要再对数据盘单独处理
			if (!this.deviceCustomPartitionSupport) {
				return
			}
			if (item.raidType === 'NORAID') {
				this.dataDiskPartitionModes = [
					{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' },
				];
			} else {
				this.dataDiskPartitionModes = [
					{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' },
					{ id: 2, label: this.$t('create.text.customPartitionModes'), value: 'custom' },
				];
			}
			this.selectedDataDiskPartitionMode = 'default';
		},

		// 是否支持自定义分区
		resetPartitionModes(customPartitionSupport) {
			if (!customPartitionSupport) {
				this.systemDiskPartitionModes = [
					{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' }
				];
				this.dataDiskPartitionModes = [
					{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' }
				];
			} else {
				this.systemDiskPartitionModes = [
					{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' },
					{ id: 2, label: this.$t('create.text.customPartitionModes'), value: 'custom' },
				],
					this.dataDiskPartitionModes = [
						{ id: 1, label: this.$t('create.text.defaultPartitionModes'), value: 'default' },
						{ id: 2, label: this.$t('create.text.customPartitionModes'), value: 'custom' },
					];
			}
			this.selectedPartitionMode = 'default';
			this.selectedDataDiskPartitionMode = 'default';
		},

		getOSPartitions() {
			if (!this.selectedOSTypeId || !this.selectedRegion || !this.selectedStandard) {
				return
			}
			const param = {
				region: this.selectedRegion,
				deviceType: this.selectedStandard,
				imageId: this.selectedOSTypeId
			};
			Ajax.get('/api/cps/getOSPartitions', param)
				.then((res) => {
					let partitions = res.data.partitions;
					this.handleSystemPartitions(partitions);
					this.handleDataPartitions(partitions);
				}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},

		dealRemainSystemDataPartitions(diskSize, diskPartitions) {
			return diskSize - diskPartitions.filter(item => item.size !== 999999999).reduce((init, current) => {
				return init + current.size
			}, 0);
		},

		dealDefaultPartitions(partitions) {
			let defaultPartitions = deepCopy(partitions);
			defaultPartitions.map((item) => {
				item.size = item.isRemainDataPartition ? this.$t('retailInstance.text.allRemainingSpace') : `${item.size}GiB`;
			});

			return defaultPartitions.reduce((init, current) => {
				return `${init}<strong class="ml5 mr5">${current.point}:</strong><span>${current.size},${current.format};</span>`
			}, '')
		},

		handlePartitions(remainPartitions, diskPartitions, type) {
			let hasRemainDataPartition = false;
			let systemDataPartitions = diskPartitions.map(item => {
				item.isEditing = false;
				if (item.size === 999999999) {
					item.size = remainPartitions;
					item.isRemainDataPartition = true;
					hasRemainDataPartition = true;
				}
				item.size = item.size / 1024;
				return item
			});

			if (type === 'systemDisk') {
				this.defaultSystemDataPartitions = this.dealDefaultPartitions(systemDataPartitions);
			} else if (type === 'dataDisk') {
				this.defaultDataDiskPartitions = this.dealDefaultPartitions(systemDataPartitions);
			}
			systemDataPartitions.push({
				point: this.$t('retailInstance.text.emptyPartition'),
				isEditing: false,
				size: hasRemainDataPartition ? 0 : parseInt(remainPartitions / 1024, 10),
				format: this.isCentOS66 ? 'ext3' : 'xfs',
				isNoPartition: true
			});
			systemDataPartitions.map(item => {
				if (item.point === '/') {
					item.minSize = 5;
				} else if (item.point === '/boot') {
					item.minSize = 1;
				} else {
					item.minSize = 0;
				}
				item.maxSize = item.size + (hasRemainDataPartition ? 0 : parseInt(remainPartitions / 1024, 10))
				return item
			});
			return systemDataPartitions
		},

		handleSystemPartitions(partitions) {
			let remainSystemDataPartitions = this.dealRemainSystemDataPartitions(this.systemDiskSize * 1024, partitions.systemDiskPartitions);
			this.systemDataPartitions = this.handlePartitions(remainSystemDataPartitions, partitions.systemDiskPartitions, 'systemDisk');
		},

		handleDataPartitions(partitions) {
			let remainSystemDataPartitions = this.dealRemainSystemDataPartitions(this.dataDiskSize * 1024, partitions.dataDiskPartitions);
			this.dataDiskPartitions = this.handlePartitions(remainSystemDataPartitions, partitions.dataDiskPartitions, 'dataDisk');
		},
		resetDiskCapacity(type) {
			if (!this.selectedOSTypeId || !this.selectedRegion || !this.selectedStandard) {
				return
			}
			const param = {
				region: this.selectedRegion,
				deviceType: this.selectedStandard,
				imageId: this.selectedOSTypeId
			};
			Ajax.get('/api/cps/getOSPartitions', param)
				.then((res) => {
					let partitions = res.data.partitions;
					if (type === 'system') {
						this.handleSystemPartitions(partitions);
					} else if (type === 'data') {
						this.handleDataPartitions(partitions);
					}
				}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},

		calculateDiskCapacity(type, capacity) {
			let diskCapacity = Math.floor(capacity * 0.93);
			if (type === 'system') {
				this.sysDiskCapacity = diskCapacity + 'GiB';
				this.systemDiskSize = diskCapacity;
			} else if (type === 'data') {
				this.dataDiskCapacity = diskCapacity + 'GiB';
				this.dataDiskSize = diskCapacity;
			}
		},

		partitionModeChange() {

		},
		checkStockEnough(region, az, selectedStandard, selectedHostNumber, init) {
			// init 用来区分是不是初始化,不是初始化,则不用传值,是初始化则传true
			if (!region || !az || !selectedStandard) {
				return;
			}
			const param = {
				region,
				az,
				deviceType: selectedStandard,
				count: selectedHostNumber
			};
			Ajax.get({
				url: '/api/bm',
				action: '/isStockEnough',
				param,
				success: (data) => {
					this.deviceTypesNum[selectedStandard] = data;
					const newDeviceTypesNum = $.extend(true, {}, this.deviceTypesNum);
					this.deviceTypesNum = $.extend(true, {}, newDeviceTypesNum);
					if (init) {
						this.cacheDeviceTypesNum[selectedStandard] = data;
						const cacheDeviceTypesNum = $.extend(true, {}, this.cacheDeviceTypesNum);
						this.cacheDeviceTypesNum = $.extend(true, {}, cacheDeviceTypesNum);
						this.cacheDeviceTypesNum[''] = false;
						for (let z = 0; z < this.deviceTypesArr.length; z++) {
							const name = this.deviceTypesArr[z].deviceType;
							this.allSold = this.allSold && (this.deviceTypesNum[name] != undefined || this.deviceTypesNum[name] != false);
						}
						// 历史逻辑（初始化库存回调中循环赋值selectedStandard）已注释，避免重复赋值覆盖当前系列默认值
						// for (let z = 0; z < this.deviceTypesArr.length; z++) {
						// 	const name = this.deviceTypesArr[z].deviceType;
						// 	this.allSold = this.allSold && (this.deviceTypesNum[name] != undefined || this.deviceTypesNum[name] != false);
						// 	if (this.deviceTypesNum[name]) {
						// 		this.selectedStandard = name;
						// 		break;
						// 	}
						// }
					}
					if (this.deviceTypesNum[this.selectedStandard] !== undefined) {
						this.isStockEnough = this.deviceTypesNum[this.selectedStandard];
					}
				}
			});
		},
		calculateTotalPrice() {
			if (!this.selectedRegion || !this.selectedStandard) {
				return '';
			}
			this.isCalculatIng = true;
			this.discountedTotalPrice = this.$t('create.text.calculating');
			this.discountedServerPrice = this.$t('create.text.calculating');
			this.totalPrice = this.$t('create.text.calculating');
			this.totalDiscount = this.$t('create.text.calculating');
			const param = {
				cmd: 1, // 创建
				region: this.selectedRegion,
				timeUnit: this.timeUnit, // 月
				timeSpan: this.timeUnit == 3 ? this.selectedMonth : this.selectedYear,
				count: this.selectedHostNumber,
				deviceType: this.selectedStandard,
				createType: CreateTypeConstant.VPC,
				billingType: BillingTypesConstant.PREPAID_BY_DURATION
			};
			// 如果非整数，不计算价格
			if (!/^\d+$/.test(this.selectedHostNumber)) {
				return false;
			}
			Ajax.get('/api/price/calculateTotalPrice', param).then(res => {
        const { discountedTotalPrice, list, totalPrice, totalDiscount } = res?.data || {};
				this.discountedTotalPrice = changeTwoDecimal(discountedTotalPrice);
				this.discountedServerPrice = changeTwoDecimal(list.length ? list[0]?.discountedPrice : '');
				this.totalPrice = changeTwoDecimal(totalPrice);
				this.totalDiscount = changeTwoDecimal(totalDiscount);
        this.favorablePricePerHour = totalDiscount ? changeTwoDecimal(subDecimals(totalPrice, discountedTotalPrice)) : '--';
			}).catch(() => {
				this.clearPrice();
			})
			.finally(() => {
				this.isCalculatIng = false;
			});
			return '';
		},
		configurationsCalculateTotalPrice() {
			if (!this.selectedRegion || !this.selectedStandard) {
				return '';
			}
			this.isConfigurationsCalculatIng = true;
			this.discountByConfigurationsOneMonthPrice = this.$t('create.text.calculating');
			this.discountByConfigurationsServerPriceOneHour = this.$t('create.text.calculating');
			const param = {
				cmd: 1, // 创建
				region: this.selectedRegion,
				count: this.selectedHostNumber,
				deviceType: this.selectedStandard,
				createType: CreateTypeConstant.VPC,
				billingType: BillingTypesConstant.POSTPAID_BY_DURATION
			};
			// 如果非整数，不计算价格
			if (!/^\d+$/.test(this.selectedHostNumber)) {
				return false;
			}
			Ajax.get('/api/price/calculateTotalPrice', param).then(res => {
        const { discountedTotalPrice, list, totalPrice, totalDiscount } = res?.data || {};
				this.discountByConfigurationsOneMonthPrice = changeTwoDecimal(mulDecimals(mulDecimals(discountedTotalPrice, 24), 30));
				this.discountByConfigurationsServerPriceOneHour = changeTwoDecimal(list.length ? list[0]?.discountedPrice : '');
				this.configurationTotalPrice = changeTwoDecimal(totalPrice);
				this.configurationTotalDiscount = totalDiscount ? changeTwoDecimal(subDecimals(totalPrice, discountedTotalPrice)) : '--';
			}).catch(() => {
				this.clearPrice();
			}).finally(() => {
				this.isConfigurationsCalculatIng = false;
			});
			return '';
		},
		selectStandard(standard) {
			if (!this.deviceTypesNum[standard]) {
				return;
			}
			this.selectedStandard = standard;
			this.selectedApplication = [];
		},
		selectApplication(name) {
			for (var i in this.selectedApplication) {
				if (name == this.selectedApplication[i].name) {
					this.selectedApplication.splice(i, 1);
					return;
				}
			}
			const arr = [];
			for (var i in this.applications) {
				if (name == this.applications[i].name) {
					this.selectedApplication.push({ name, version: this.applications[i].version });
					return;
				}
			}
		},
		selectDataRaid(item) {
			this.resetDataPartitionModes(item);
			this.selectedDataRaid = item;
			this.selectedDataRaidId = item.raidTypeId;
			const dataVolume1 = item.volumeDetail.split(' ').join('');
			const dataVolume2 = dataVolume1.split('TB').join('TB ');
			const dataVolume = dataVolume2.split('GB').join('GB ');
			const dataRaidType = `, ${this.radisNameMap[item.raidType]})`;
			const dataRaidName = dataVolume.replace(')', dataRaidType);
			let dataDiskCapacity = item.availableValue;
			this.calculateDiskCapacity('data', dataDiskCapacity);
			// 重置数据盘
			this.resetDiskCapacity('data');
			this.selectedDataRaidName = dataRaidName;
		},
		selectMonth(selMonth) {
			this.chargeUnit = 3;
			this.timeUnit = 3;
			this.selectedMonth = selMonth;
			this.otherMonth = selMonth;
			switch (selMonth) {
				case 12:
					this.cutMonth = 2;
					break;
				case 24:
					this.cutMonth = 4;
					break;
				case 36:
					this.cutMonth = 6;
					break;
				default:
					this.cutMonth = 0;
			}
		},
		selectYear(selYear) {
			switch (selYear) {
				case 1:
					this.selectedMonth = 12;
					break;
				case 2:
					this.selectedMonth = 24;
					break;
				case 3:
					this.selectedMonth = 36;
					break;
				default:
					this.cutMonth = 0;
			}
			this.selectedYear = selYear;
			this.chargeUnit = 4;
			this.timeUnit = 4;
		},

		jump_to_up() {
			this.$router.push({
				path: '/instance/retail/list',
				query: {
					region: this.selectedRegion
				}
			});
		},
		/**
		 **@disc:定位到页面上未通过校验元素
		 **@params: element id
		 */
		locateToErrorElement(id) {
			$('.mainCon').scrollTop($('.mainCon').scrollTop() + $(`#${id}`).offset().top
				- $('.mainCon').offset().top - 100);
		},
		buy() {
			let formValid = true;
			this.$refs.ruleFormType.validate((valid) => {
				formValid = valid;
			});
			if (!formValid) {
				if (this.$refs.application !== undefined) {
					this.ruleFormTag.application = this.$refs.application.validateState;
				}
				this.locateToErrorElement('imgType');
				return false;
			}
			// 校验系统盘及数据盘自定义分区模式下是否保存
			if (this.$refs.systemPartition && this.$refs.systemPartition.isRowNotSaved) {
				this.locateToErrorElement('storage');
				return false;
			}
			if (this.$refs.dataPartition && this.$refs.dataPartition.isRowNotSaved) {
				this.locateToErrorElement('storage');
				return false;
			}
			this.$refs.advancedCustomData.$refs.advanced.validate((valid) => {
				formValid = valid;
			});
			if (!formValid) {
				this.locateToErrorElement('advanced');
				return false;
			}
			this.$refs.tagForm.validate((valid) => {
				formValid = valid;
			});
			if (!formValid) {
				this.locateToErrorElement('advanced');
				return false;
			}
			this.$refs.ruleForm.validate((valid) => {
				formValid = valid;
			});

			if (!formValid) {
				this.ruleFormTag.hostName = this.$refs.hostName.validateState;
				this.ruleFormTag.hostDesc = this.$refs.hostDesc.validateState;
				this.ruleFormTag.hostPwd = this.$refs.hostPwd.validateState;
				this.ruleFormTag.hostConfirmPwd = this.$refs.hostConfirmPwd.validateState;
				this.ruleFormTag.mainName = this.$refs.mainName.validateState;
				this.locateToErrorElement('baseInfo');
				return false;
			}
			this.createOrder();
		},
		createOrder() {
			const selectedDeviceData = this.deviceTypes[this.selectedStandard];
			const selectedDeviceName = selectedDeviceData.deviceType;
			let systemDiskPartitions = this.systemDataPartitions.filter(item => !item.isNoPartition).map(item => {
				return {
					"size": item.size,
					"format": item.format,
					"point": item.point
				}
			});
			if (this.selectedPartitionMode === 'default') {
				systemDiskPartitions = [];
			}
			let dataDiskPartitions = this.dataDiskPartitions.filter(item => !item.isNoPartition).map(item => {
				return {
					"size": item.size,
					"format": item.format,
					"point": item.point
				}
			});
			if (this.selectedDataDiskPartitionMode === 'default') {
				dataDiskPartitions = [];
			}
			const param = {
				orderType: 1, // 新购
				chargeMode: this.currentMode === 'tab1' ? 3 : 1, // 计费类型 包年包月
				region: this.selectedRegion,
				az: this.selectedZone,
				deviceType: this.selectedStandard,
				imageType: 'standard', // 镜像类型
				imageName: this.selectedOSName,
				deviceName: selectedDeviceName,
				osTypeId: this.selectedOSTypeId,
				sysRaidTypeId: this.selectedOSRaidId, // 系统盘raid
				systemDiskPartitions,
				dataRaidTypeId: this.selectedDataRaidId, // 数据盘raid
				dataDiskPartitions,
				sysRaidName: this.selectedSysRaidName,
				dataRaidName: this.selectedDataRaidName,
				interfaceMode: this.selectedNetworkQuantity,
				name: this.ruleForm.hostName,
				description: this.ruleForm.hostDesc,
				chargeDuration: this.chargeUnit == 3 ? this.selectedMonth : this.selectedYear,
				chargeUnit: this.chargeUnit, // 月 计费时长单位 1:小时 2:天 3:月 4:年
				quantity: this.selectedHostNumber,
				clientToken: Normal.getClientToken(),
				timestamps: Normal.getClientToken(),
				autoRenew: this.autoRenew,
				hostname: this.ruleForm.mainName,
				networkType: 'retail',
				createType: 'vpc',
				userData: this.advancedSetting ? this.userData : undefined, // 高级设置的脚本
				resourceTags: this.tagForm.tags
			};
			// 密钥登陆参数处理
			if (this.passwordType === 'custom') {
				param.loginType = 'pwd';
				param.password = this.ruleForm.hostPwd;
			} else if (this.passwordType === 'key') {
				param.loginType = 'keyPair';
				param.password = '';
				param.keyPairId = this.ruleForm.selectKey;
			} else {
				param.loginType = 'autoPwd';
			}

			Ajax.post('/api/cps/instances/createInstance', param, {
				headers: {
					'Content-Type': 'application/json'
				}
			}).then((res) => {
				const orderId = res.data.tempOrderNumber;
				if (orderId !== '' && orderId !== undefined) {
					window.location.href = `${this.Config.ORDER_URL}/confirm?buyId=${orderId}&source=1`;
				}
			})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
		},
		setTab(name, cursel, n) {
			for (let i = 1; i <= n; i++) {
				const menu = document.getElementById(name + i);
				const con = document.getElementById(`con-${name}-${i}`);
				menu.className = i == cursel ? 'hover' : '';
			}
			this.currentMode = name + cursel;
		},
		// 获取折扣信息
		getDiscountInfo() {
			const param = {
				serviceCode: ServiceCodeConstant["CPS|EIP"],
				billType: 2, // 包年包月
				billPeriod: '1,2,3',
				timeUnit: 4, // 年
				region: this.selectedRegion,
				buyType: 1// 1、新购2、续费3、配置变更
			};
			Ajax.get({
				url: '/api/discount',
				action: '/describeLowestDiscount',
				param,
				success: (data) => {
					if (data.length > 0) {
						for (let i = 0; i < data.length; i++) {
							this.allDiscountedInfo[i].message[0] = data[i].discounts[0].message;
							this.allDiscountedInfo[i].message[1] = data[i].discounts[1].message;
						}
					}
				}
			});
		},

		doClose() {
			this.dialogVisible = false;
		},
		doConfirm() {
			this.dialogVisible = false;
		},
		getCurrentSeries(selectedStandard) {
			const allSeries = this.deviceTypesTable;
			for (const item in allSeries) {
				for (const deviceItem in allSeries[item]) {
					if (allSeries[item][deviceItem].deviceType === selectedStandard) {
						this.selectedSeries = item;
					}
				}
			}
		},
		isIncludeBra(value) {
			if (value.includes('(') && value.includes('generation')) {
				return value.replace('(', '<br>(');
			}
			if (value.includes('（') && value.includes('generation')) {
				return value.replace('（', '<br>（');
			}
			return value;
		},

		// 添加标签错误处理
		errorHandler(err) {
			console.log(err)
		},

		/**
		 * 折叠已选配置项
		*/
		collapseSelected(tag) {
			this[tag].collapseSelected = !(this[tag].collapseSelected);
		},
	}
};
</script>

<style lang="scss">
@import '../../../assets/scss/createCommon';
@import '../../../assets/scss/statusCommon';
@import '../../../assets/scss/sliderCommon';
@import '../../../assets/scss/selectedConfigure';
@import 'style';

.create-container {
	.search-input {
		width: 200px !important;
		margin: 5px;
	}

	.search-icon {
		margin: 5px;
	}

	.search-label {
		padding-top: 10px;
	}

	.select-type {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		margin-left: 130px;
		border-left: 1px solid #dbe3e9;
		border-right: 1px solid #dbe3e9;
		border-top: 1px solid #dbe3e9;
		padding: 5px 5px 5px 10px;
	}

	.defaultPartition {
		span {
			color: #9e9e9e;
		}
	}
}</style>
<style lang="scss" scoped>
	.price {
		font-size: 22px !important;
	}
</style>


// WEBPACK FOOTER //
// src/views/retailInstance/create/RetailInstanceCreate.vue